"use client";
import l, { useId as d } from "react";
import "./index.es9.js";
import "./index.es10.js";
import "./index.es11.js";
import "./index.es12.js";
import "./index.es13.js";
import "./index.es14.js";
import v from "./index.es15.js";
import _ from "./index.es59.js";
const o = "__EMPTY_STR__", f = _.div`
  .bl-select select[disabled] {
    background-color: var(--bl-c-sand-4);
    color: var(--bl-c-neutral-1);
  }
  .bl-select .bl-input {
    display: flex;
    align-items: center;
  }
`, R = ({
  name: m,
  value: a,
  label: i,
  options: t,
  onChange: b
}) => {
  const c = d(), s = t.map(
    (e) => e.value !== "" ? e : { value: o, label: e.label }
  ), u = (e) => {
    let r = e.target.value;
    r === o && (r = ""), b(r);
  }, n = t.length < 2, p = t.find((e) => e.value === a)?.label || a;
  return /* @__PURE__ */ l.createElement(f, null, n && /* @__PURE__ */ l.createElement("div", { className: "bl-select" }, /* @__PURE__ */ l.createElement("div", { className: "bl-select__label bl-size-6 bl-p-b-1" }, i), /* @__PURE__ */ l.createElement("div", { className: "bl-input" }, p)), !n && /* @__PURE__ */ l.createElement(
    v,
    {
      isDisabled: n,
      label: i,
      name: m,
      value: a,
      onChange: u,
      inputId: c
    },
    s.map((e) => /* @__PURE__ */ l.createElement(
      "option",
      {
        key: e.value,
        value: e.value,
        "aria-label": e.ariaLabel
      },
      e.label
    ))
  ));
};
export {
  R as default
};
//# sourceMappingURL=index.es16.js.map
